<template>
  <div id="compair-chart">
    <div id="chart-area" ref="chartdiv"></div>
  </div>
</template>
<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4lang_th_TH from "@amcharts/amcharts4/lang/th_TH";

export default {
  name: "compaireChart",
  props: {
    transferData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      valueAxis: null,
    };
  },
  watch: {
    transferData(data) {
      if (data) {
        this.init();
      }
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const refsDiv = this.$refs.chartdiv;
      const chart = am4core.create(refsDiv, am4charts.XYChart);
      const locale = this.$i18n.locale;
      if (locale == "th") {
        chart.language.locale = am4lang_th_TH;
        chart.numberFormatter.language = new am4core.Language();
        chart.numberFormatter.language.locale = am4lang_th_TH;
        chart.dateFormatter.language = new am4core.Language();
        chart.dateFormatter.language.locale = am4lang_th_TH;
      }

      chart.width = am4core.percent(100);
      chart.height = am4core.percent(100);
      chart.legend = new am4charts.Legend();
      chart.data = this.transferData;

      // Create axes
      var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      dateAxis.renderer.minGridDistance = 50;

      const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

      // Create series
      var series = chart.series.push(new am4charts.LineSeries());
      series.dataFields.valueY = "value1";
      series.dataFields.dateX = "date";
      series.strokeWidth = 5;
      series.minBulletDistance = 10;
      series.tooltipText =
        "[bold]{date.formatDate()}:[/] {value1}\n[bold]{previousDate.formatDate()}:[/] {value2}";
      series.tooltip.pointerOrientation = "vertical";
      series.name = "transfer";
      series.stroke = series.fill = am4core.color("red");

      // Add cursor
      chart.cursor = new am4charts.XYCursor();
      chart.cursor.xAxis = dateAxis;
      this.valueAxis = valueAxis;

      var bullet = series.bullets.push(new am4charts.CircleBullet());
      bullet.circle.fill = series.fill;
    },
  },
};
</script>
<style scoped>
#chart-area {
  width: 100%;
  height: 345px;
}
</style>